export const resolveImageUrl = (fileName: string) => {
  if (process.env.NODE_ENV === 'development') {
    return `images/${fileName}`
  }
  return `static/soc-website/images/${fileName}`
}
